module.exports = __webpack_public_path__ + "static/img/000.614e351e.png";